<template>
  <vs-popup
    :active.sync="isModalActive"
    @close="closeModal"
    title="Mensagens Excluídas"
    id="modal-msg-deleted"
  >
    <div class="flex items-center justify-end">
      <vs-input icon="search" icon-before="true" v-model="filterCriteria" />
    </div>
    <div class="overflow-x-auto w-full">
      <GenericTable
        :headers="tableHeaders"
        :items="filteredItems"
        :buttons="tableButtons"
      />
    </div>
    <ModalMensagemFilesPhotos
      ref="photosMessagesModal"
      :idPropostaNota="idPropostaNota"
    />
  </vs-popup>
</template>

<script>
import GenericTable from '../../components/generic/GenericTable.vue';
import ModalMensagemFilesPhotos from './ModalMensagemFilesPhotos.vue';

export default {
  name: 'ModalMensagemHistorico',
  props: {
    headers: Array,
    items: Array,
    buttons: Array,
  },
  data() {
    return {
      isModalActive: false,
      tableHeaders: [
        { key: 'assunto', label: 'Assunto' },
        { key: 'mensagem', label: 'Mensagem' },
        { key: 'createdAt', label: 'Data', isDate: true },
        { key: 'createdAt', label: 'Hora', isTime: true },
        { key: 'usuarios.nome', label: 'Usuário' },
        {
          key: 'usuarios.Usuarios_Perfil.nomePerfil',
          label: 'Perfil de Usuário',
        },
      ],
      tableButtons: [
        {
          iconPack: 'feather',
          icon: 'icon-more-horizontal',
          color: '#1F74FF',
          action: (item) => {
            this.openPhotosMessagesModal(item.idPropostaNota);
          },
        },
      ],
      filterCriteria: '',
      idPropostaNota: null,
    };
  },
  methods: {
    closeModal() {
      this.isModalActive = false;
    },
    openPhotosMessagesModal(idPropostaNota) {
      this.idPropostaNota = idPropostaNota;
      this.$refs.photosMessagesModal.isModalActive = true;
    },
  },
  computed: {
    filteredItems() {
      const filter = this.filterCriteria.toLowerCase();
      return this.items.filter((item) =>
        item.assunto.toLowerCase().includes(filter),
      );
    },
  },
  components: { GenericTable, ModalMensagemFilesPhotos },
};
</script>

<style lang="css">
#modal-msg-deleted .vs-popup {
  width: 80%;
}
</style>
